export const COLUMN_SETTINGS_DND_TYPE = 'column-setting'

export const SHOWN_SECTION = 'shown'

export const HIDDEN_SECTION = 'hidden'

export const ROW_HOVER_REVEAL_CLASS = 'column-settings-hover-reveal'

export const ROW_HOVER_CONCEAL_CLASS = 'column-settings-hover-conceal'
